// extracted by mini-css-extract-plugin
module.exports = {"marginBottomMedium":"PostBookingPaymentInner-module__marginBottomMedium___VPehM"};